<template>
  <div class="status-item-container">
    <span v-if="status.value == 0 && status.value !== ''" class="completed">{{
      status.label
    }}</span>
    <span v-else-if="status.value == 1" class="pending">{{
      status.label
    }}</span>
    <span v-else-if="status.value == 2" class="accepted">{{
      status.label
    }}</span>
    <span v-else-if="status.value == 3" class="inTransit">{{
      status.label
    }}</span>
    <span v-else-if="status.value == 4" class="decilned">{{
      status.label
    }}</span>
    <span v-else-if="status.value == 5" class="submitted">{{
      status.label
    }}</span>
    <span v-else-if="status.value == 6" class="unassigned">{{
      status.label
    }}</span>
    <span v-else-if="status.value == 7" class="delivered">{{
      status.label
    }}</span>
    <span v-else-if="status.value == 8" class="paid">{{ status.label }}</span>
    <span v-else-if="status.value == 9" class="invoiced">{{
      status.label
    }}</span>
    <span v-else-if="status.value == 10" class="new-invoiced">{{ status.label }}</span>
    <span v-else-if="status.value == 11" class="Overdue">{{ status.label }}</span>
    <span v-else-if="status.value == 12" class="new-paid">{{ status.label }}</span>
    <span v-else-if="status.value == 13" class="new-cancelled">{{ status.label }}</span>
    <span v-else style="text-align: left">--</span>
  </div>
</template>
<script>
export default {
  name: "",
  components: {},
  props: {
    status: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {};
  },
  computed: {},
  methods: {},
};
</script>

<style lang="scss" scoped>
.status-item-container {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  min-height: 26px;
  span {
    display: inline-block;
    min-width: 76px;
    height: 24px;
    text-align: center;
    line-height: 24px;
    border-radius: 2px;
    font-weight: 600;
    font-size: 12px !important;
    width: 76px;
    height: 24px;
    display: inline-block;
    text-align: center;
    line-height: 24px;
  }
  .completed {
    background-color: #ebecef;
    color: #4c556c !important;
  }
  .pending {
    background-color: #fff2d9;
    color: #d89800 !important;
  }
  .accepted {
    background-color: rgba(0, 141, 125, 0.1);
    color: #008d7d !important;
  }
  .inTransit {
    background-color: #e0f4f6;
    color: #006da5 !important;
  }
  .decilned {
    background-color: #fae6e8;
    color: #cf1322 !important;
  }
  .submitted {
    background-color: #e5f4ec;
    // opacity: 0.12;
    color: #29a360 !important;
  }
  .unassigned {
    background-color: #fdede0;
    color: #f08226 !important;
  }
  .delivered {
    // opacity: 0.12;
    background-color: #eee3f6;
    color: #761ab7 !important;
  }
  .submitted {
    background-color: #e5f4ec;
    // opacity: 0.12;
    color: #29a360;
  }
  .unassigned {
    background-color: #fdede0;
    color: #f08226;
  }
  .delivered {
    // opacity: 0.12;
    background-color: #eee3f6;
    color: #761ab7;
  }
  .paid {
    // opacity: 0.12;
    background-color: #fae6ed;
    color: #bc13a4 !important;
  }
  .invoiced {
    // opacity: 0.12;
    background-color: #d9f1ed;
    color: #0da58c !important;
  }
  .new-invoiced {
    background-color: #e0f4f6;
    color: #006da5 !important;
  }
  .Overdue {
    background-color: rgba(222, 70, 82, 0.1);
    color: #de4652 !important;
  }
  .new-paid {
    background-color: #d8f4de;
    color: #08a713 !important;
  }
  .new-cancelled {
    background-color: #f0f2f5;
    color: #7f8596 !important;
  }
}
</style>
